var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPairTables(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "211.98mm",
    height: "116.32mm",
    viewBox: "0 0 211.98 116.32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5416 5.8347)",
    fill: "#00c0ff",
    stroke: "#000",
    strokeWidth: 0.37118
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.63 .53454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.014,
    y: 3.8805,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.675,
    y: 3.8805,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.34,
    y: 3.8163,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 3.8163,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.48 -.47396)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -49.836,
    y: 30.308,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.82524,
    y: 30.308,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.487,
    y: 30.244,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.15,
    y: 30.244,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.63 51.373)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.014,
    y: 3.8805,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.675,
    y: 3.8805,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.34,
    y: 3.8163,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 3.8163,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.48 50.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -49.836,
    y: 30.308,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.82524,
    y: 30.308,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.487,
    y: 30.244,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.15,
    y: 30.244,
    width: 39.629,
    height: 19.629,
    opacity: 0.996
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairTables);
export default __webpack_public_path__ + "static/media/pair_tables.9a94be997d220fa55e143b68a0355921.svg";
export { ForwardRef as ReactComponent };